import React from 'react';
import { designSystem } from '@yola/ws-ui';
import classNames from 'classnames';
import PropTypes from 'prop-types';

const { Icon, Heading, Paragraph, Stack, SelectedIcon } = designSystem;

const DifmBannerSelectItem = ({
  iconGlyph = '',
  title,
  subTitle = '',
  description,
  subDescription = '',
  active = false,
  value,
  onClick,
}) => {
  const classes = classNames('ws-difm-banner-select-item', {
    'ws-difm-banner-select-item--active': active,
  });

  const handleClick = () => onClick(value);

  return (
    <div className={classes} onClick={handleClick}>
      {iconGlyph && <Icon type="accent" glyph={iconGlyph} />}
      <div className="ws-difm-banner-select-item__content">
        <Stack gap="spacing-4-xs">
          <div className="ws-difm-banner-select-item__header">
            {active && subTitle && <SelectedIcon />}
            <div className="ws-difm-banner-select-item__header-title">
              <Heading type="heading-6">{title}</Heading>
            </div>
            {subTitle && <Heading type="heading-6">{subTitle}</Heading>}
          </div>
          <Paragraph size="small" appearance="medium-emphasis">
            {description}
          </Paragraph>
          {subDescription && (
            <Paragraph size="small">
              <b>{subDescription}</b>
            </Paragraph>
          )}
        </Stack>
      </div>
      {active && !subTitle && (
        <div className="ws-difm-banner-select-item__icon">
          <SelectedIcon />
        </div>
      )}
    </div>
  );
};

DifmBannerSelectItem.propTypes = {
  active: PropTypes.bool,
  iconGlyph: PropTypes.oneOf(['brush', 'sparkles', 'repeat', '']),
  value: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  subDescription: PropTypes.string,
  subTitle: PropTypes.string,
  onClick: PropTypes.func.isRequired,
};

export default DifmBannerSelectItem;
